import { render, staticRenderFns } from "./BaseExams.vue?vue&type=template&id=75c98b63&scoped=true&"
import script from "./BaseExams.vue?vue&type=script&lang=js&"
export * from "./BaseExams.vue?vue&type=script&lang=js&"
import style0 from "./BaseExams.vue?vue&type=style&index=0&id=75c98b63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c98b63",
  null
  
)

export default component.exports